import React from "react";
import moment, { Duration, Moment } from "moment";

import styles from "./ETADisplayer.css";
import HourglassIcon from "../../images/ic-hourglass.svg";
import LocationPinIcon from "../../images/ic-location.svg";

interface ETADisplayerProps {
  estimatedTimeOfArrival: Moment;
  remainingDistance: string;
  estimatedDuration: Duration;
}

const formattedETA = (estimatedDuration: Duration) => {
  if (!estimatedDuration) {
    return "-";
  }

  const hours = Math.floor(estimatedDuration.asHours());
  const minutes = Math.floor(estimatedDuration.asMinutes() - hours * 60);

  const displayHours = hours > 0 ? `${hours} h ` : "";
  const displayMinutes = minutes > 0 ? `${minutes} min` : "";

  return displayHours + displayMinutes;
};

export const ETADisplayer = ({
  estimatedTimeOfArrival,
  remainingDistance,
  estimatedDuration
}: ETADisplayerProps) => (
  <div className={styles.container}>
    <div className={styles.containerInfo}>
      Previsão de chegada
      <div className={styles.time}>
        {moment(estimatedTimeOfArrival).format("HH:mm")}
      </div>
    </div>
    <div className={styles.containerIcons}>
      <HourglassIcon className={styles.hourglassIcon} />
      {estimatedDuration && formattedETA(estimatedDuration)}
      <LocationPinIcon className={styles.locationPinIcon} />
      {remainingDistance}
    </div>
  </div>
);
